type FooterSocialLinkKey = 'telegram' | 'whatsapp';
type FooterDirectContactKey = 'phone' | 'email';

export interface FooterSocialLink {
  key: FooterSocialLinkKey;
  value: string;
  href: string;
}

export interface FooterDirectContact {
  key: FooterDirectContactKey;
  value: string;
  href: string;
}

export const footerContent = {
  socialLinks: [
    {
      key: 'telegram',
      value: 't.me/live_netbot',
      href: 'https://t.me/live_netbot',
    },
  ] as FooterSocialLink[],
  directContacts: [
    {
      key: 'email',
      value: 'admin@hearthnexus.com',
      href: 'mailto:admin@hearthnexus.com',
    },
    { key: 'phone', value: '+7 (953) 482-62-08', href: 'tel:+79534826208' },
  ] as FooterDirectContact[],
};
